/**
 * Clear the stale Posti pickup point validation error when the customer
 * switches from a shipping method to WooCommerce Local Pickup.
 */
(() => {
    // Run only on the WooCommerce checkout page.
    if (!document.body.classList.contains('woocommerce-checkout')) {
        return;
    }

    // Stop if WooCommerce Blocks data is not available.
    if (!window.wc?.wcBlocksData || !window.wp?.data) {
        return;
    }

    const { select, dispatch, subscribe } = wp.data;
    const { checkoutStore, validationStore } = window.wc.wcBlocksData;

    // Store the current pickup state so we can detect changes
    let previousPickupState = select(checkoutStore).prefersCollection();

    function handlePickupChange() {
        const isPickup = select(checkoutStore).prefersCollection();

        // Do nothing if the shipping/pickup state has not changed.
        if (isPickup === previousPickupState) {
            return;
        }

        previousPickupState = isPickup;

        // Only handle the error when Local Pickup is selected.
        if (!isPickup) {
            return;
        }
        const errors = select(validationStore).getValidationErrors();

        // Clear only the stale Posti pickup point validation error.
        if (errors?.posti_pickup_point_error) {
            dispatch(validationStore).clearValidationError(
                'posti_pickup_point_error'
            );
        }
    }
    // Listen for checkout state changes.
    subscribe(handlePickupChange);
})();
